/* eslint-disable brace-style */
// Conflicting with prettier..
import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  AbstractFormDialog,
  AbstractFormDialogData,
  AbstractDialogResultData,
  DIALOG_RETURN_TYPES,
} from '@next/core-lib/dialog';

import {
  SoilType,
  UnitOfMeasure,
  NutrientDesignation,
  NutrientSource,
  UpsertNutrientPropertiesRequest,
  NutrientProperties,
  SoilTargetUoMEnum,
  NutrientPropertiesSampleNumber,
} from '../../models';
import { decimalValidator } from '../../validators';

export interface CreateNutrientPropertyDialogData extends AbstractFormDialogData {
  soilTypes: SoilType[];
  unitsOfMeasure: UnitOfMeasure[];
  nutrientDesignations: NutrientDesignation[];
  nutrientSources: NutrientSource[];
  nutrientProperty?: NutrientProperties;
}

const DECIMAL_PLACES = 3;

@Component({
  selector: 'app-create-nutrient-property-dialog',
  templateUrl: './create-nutrient-property-dialog.component.html',
  styleUrls: ['./create-nutrient-property-dialog.component.scss'],
  standalone: false,
})
export class CreateNutrientPropertyDialogComponent
  extends AbstractFormDialog<UpsertNutrientPropertiesRequest>
  implements OnInit
{
  data = inject<CreateNutrientPropertyDialogData>(MAT_DIALOG_DATA);
  private readonly formBuilder = inject(FormBuilder);
  protected readonly mdDialogRef =
    inject<
      MatDialogRef<
        CreateNutrientPropertyDialogComponent,
        AbstractDialogResultData<UpsertNutrientPropertiesRequest>
      >
    >(MatDialogRef);

  formGroup: FormGroup = this.formBuilder.group({
    source: [null as string | null, Validators.required],
    nutrientDesignation: [null as string | null, Validators.required],
    soilTypeId: [null as number | null, Validators.required],
    sampleNumber: [null as NutrientPropertiesSampleNumber | null, Validators.required],
    soilTargetUoM: [null as string | null],
    soilTargetLow: [
      null as number | null,
      [Validators.min(0), Validators.max(99999), decimalValidator(DECIMAL_PLACES)],
    ],
    soilTargetHigh: [
      null as number | null,
      [Validators.min(0), Validators.max(99999), decimalValidator(DECIMAL_PLACES)],
    ],
    plantTargetUoM: [null as string | null],
    plantTargetLow: [
      null as number | null,
      [Validators.min(0), Validators.max(99999), decimalValidator(DECIMAL_PLACES)],
    ],
    plantTargetHigh: [
      null as number | null,
      [Validators.min(0), Validators.max(99999), decimalValidator(DECIMAL_PLACES)],
    ],
  });

  filteredUnitsOfMeasure = this.data.unitsOfMeasure.filter(
    (unit) => unit.name === SoilTargetUoMEnum.MgPerL,
  );

  getSampleNumbers() {
    return Object.values(NutrientPropertiesSampleNumber).filter(
      (value) => typeof value === 'number',
    );
  }

  ngOnInit(): void {
    if (this.data.nutrientProperty) {
      const { soilType, ...rest } = this.data.nutrientProperty;
      this.formGroup.patchValue({
        ...rest,
        soilTypeId: soilType.id,
      });
    }
  }

  confirm(): void {
    if (this.formGroup.valid) {
      this.mdDialogRef.close({ status: DIALOG_RETURN_TYPES.confirm, result: this.formGroup.value });
    }
  }
}
